import React from 'react';
import { render } from 'react-snapshot';
import App from './components/App';
import NotFound from './components/SEO/NotFound';
import Impressum from './components/Pages/Impressum';
import { createStore } from 'redux';
import reduce from './reducers/index';
import './index.css';
import { Provider } from 'react-redux';
import { BrowserRouter,	Route, Switch, Redirect } from "react-router-dom";
import ReactGA from 'react-ga';
import PdfGenerator from "./components/Pages/PdfGenerator";
//import registerServiceWorker from './registerServiceWorker';

ReactGA.initialize('UA-53119210-1');
let store = createStore(reduce);

render(
	<Provider store={store}>
		<BrowserRouter>
			<div>
				<Switch>
					<Route exact path="/impressum/" component={Impressum} />
					<Route exact path="/:year(201[6-9]|202[0-5])" component={App} />
					<Route exact path="/" render={() => <Redirect to={'/' + (new Date().getFullYear()) + '/'} />} />
					<Route exact path="/:year(201[6-9]|202[0-5])/schulferien/:region(burgenland|kaernten|noe|ooe|salzburg|steiermark|tirol|vorarlberg|wien)/" component={App} />
					<Route exact path="/:year(201[6-9]|202[0-5])/zum-ausdrucken/" component={PdfGenerator} />
					<Route component={NotFound} />
				</Switch>
			</div>
		</BrowserRouter>
	</Provider>,
  document.getElementById('root')
);

//registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js